import { Button } from '@material-ui/core'
import React from 'react'

export function ButtonComponent(props: { callback: any; classNames?: string; text?: string; icon?: JSX.Element; disabled?: boolean }) {
  const { callback, disabled, classNames, text, icon } = props
  return (
    <Button type='button' variant='contained' color='primary' className={classNames + ' min-width'} onClick={callback} disabled={disabled}>
      {text}
      {icon}
    </Button>
  )
}
